/*
 * Copyright (c) 2021. World Wide Generation Ltd
 */

export const languages = [
  {
    code: 'fr',
    name: 'French',
    nativeName: 'Français'
  },
  {
    code: 'de',
    name: 'German',
    nativeName: 'Deutsch'
  },
  {
    code: 'es',
    name: 'Spanish; Castilian',
    nativeName: 'Español'
  }
];

export enum ViewMode {
  Edit = 'edit',
  Import = 'import',
  AssignQuestions = 'assign-questions',
  EditQuestion = 'question',
  AssignPack = 'assign-pack',
  ImportExport = 'import-export',
  // used in Materiality Tracker
  Configuration = 'configuration',
}

export enum AssignmentViewMode {
  SubModules = 'sub-modules',
  Questions = 'questions',
}

export enum CustomMetricsViewMode {
  Dashboard = 'dashboard',
  Create = 'create',
  Manage = 'manage',
  MetricEditor = 'metric-editor',
}

export const CANNOT_EDIT_NOTE = 'Cannot be edited as metric has previously been answered.';
